import { QueryErrorBoundary } from "@components/errors/QueryErrorBoundary";
import { StudentCommunicationHistory } from "@features/student-communication-history/components/StudentCommunicationHistory";
import { LoadingIndicator } from "@ui/LoadingIndicator";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { requireRouteAudience } from "@services/router/routeAccess";

export const Route = createFileRoute(
	"/_layout/students/$studentNo/communications",
)({
	beforeLoad: requireRouteAudience(["staff"]),
	component: () => {
		const { studentNo } = Route.useParams();
		return (
			<QueryErrorBoundary title="Failed to load communications">
				<Suspense fallback={<LoadingIndicator resource="communications" />}>
					<StudentCommunicationHistory studentNo={studentNo} />
				</Suspense>
			</QueryErrorBoundary>
		);
	},
	staticData: { crumb: { label: "Communications" } },
});
